module.exports = __webpack_public_path__ + "static/img/H5.2d18657.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cowboy/H5.png
// module id = om3v
// module chunks = 0